export default {
	setListOfDeals(state, data) {
		state.listOfDeals = data;
	},

	setListOfPublicDeals(state, data) {
		state.listOfPublicDeals = data;
	},
	setListOfSuccessStories(state, data) {
		state.listOfSuccessStories = data;
	},

	setFilterValue(state, data) {
		state.filterValue = data;
	},
	setSearchSearch(state, data) {
		state.search.search = data;
	},
	setSearchStr(state, data) {
		state.search.str = data;
	},
	setSearchMajor_market(state, data) {
		state.search.major_market = data;
	},
	setSearchOrder(state, data) {
		state.search.order = data;
	},

	setPage(state, payload) {
		state.page = payload;
	},
	setPages(state, payload) {
		state.pages = payload;
	},
	setVideoGuides(state, payload) {
		state.videoGuides = payload;
	},
	setVideoGuidesError(state, payload) {
		state.videoGuidesErrors = payload;
	},
	setSubscriptionList(state, payload) {
		state.subscriptionList = payload;
	},
};
